module.exports = __webpack_public_path__ + "media/application/assets/images/company/stakeholders/arrow_up_muted-972115c65e4a60c05b10b9754ab717d0.svg";